import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import DashboardCards from "../components/DashboardCards/DashboardCards";
import { FaDollarSign, FaUserPlus, FaChartLine } from "react-icons/fa";
import "../styles/Dashboard.css";
import LineChartComponent from "../components/LineGraphComponent/LineChartComponent";
import BarChartComponent from "../components/GraphComponent/BarChartComponent";
import TableComponent from "../components/TableComponent/TableComponent";
import FarmerMap from "../components/FarmerMap/FarmerMap";
import ProductsComponent from "../components/ProductsComponent/ProductsComponent";
import UserComponent from "../components/UserComponent/UserComponent";
import TitleComponent from "../components/TitleComponent/TitleComponent";
import CustomerComponent from "../components/CustomerComponent/CustomerComponent";
import FeedbacksComponent from "../components/FeedbacksComponent/FeedbacksComponent";
import ComplainComponent from "../components/ComplainComponent/ComplainComponent";
import { useParams, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { handleGetComplainList } from "../store/actions/complainAction";
import { ICONS } from "../constants/constants";
import Loader from "../assets/images/loader.gif";
import { handleGetTenantData } from "../store/actions/tenantsActions";
import { handleGetAdminData } from "../store/actions/adminActions";
import { handleGetConsultantDetails } from "../store/actions/consultantsActions";

const Consultant = () => {
  const dispatch = useDispatch();
  const location = useLocation();
 // const consultant = location.state?.consultant; // Access supplier data
   const { adminList } = useSelector((state) => state.admin);
 // const { complainList, isLoading } = useSelector((state) => state.complain);
  const {  consultantDetails } = useSelector((state) => state.consultant);
  const { user } = useSelector((state) => state.user);

  const { id } = useParams();
  
    const { tenantData, isLoading } = useSelector((state) => state.tenants);
    const adminId = user?.id;
    const role = user?.role;
     const tenantId = role === "superadmin" ? user?.tenant?.id : null; // Save superAdminId if role is superadmin
    
      useEffect(() => {
        if (role === "superadmin" && tenantId) {
          // Fetch tenant data for superadmin
         // dispatch(handleGetTenantData(tenantId));
        } else if ((role === "admin" || role === "manager") && adminId) {
          // Fetch admin data for other roles (e.g., admin)
         // dispatch(handleGetAdminData(adminId));
        }
      }, [dispatch, adminId, tenantId, role]);
    
      const usersList = tenantData?.data?.tenant?.users;

      const superAdminConsultants = usersList?.filter(
        (user) => user.role === "consultant"
      );
    
      const consultantList =
      (role === "admin" || role === "manager")
        ? adminList?.admin?.adminUsers?.filter(
            (user) => user.role === "consultant"
          )
        : superAdminConsultants;

     // Find the specific consultant by ID
  // const consultant = consultantList?.find((consultant) => consultant.id === id);


  // const customersList = user?.adminUsers?.filter(
  //   (user) => user.role === "farmer"
  // );
  useEffect(() => {
    if (id) {
dispatch(handleGetConsultantDetails(id));
    }
    // const fetchComplaints = async () => {
    //   await handleGetComplainList(dispatch); // Wait for the API call to complete
    // };

    // fetchComplaints();
  }, [id, dispatch]); // Ensure it's called when the component mounts


  const userData = {
    id: consultantDetails?.data?.consultant?.id,
    name: consultantDetails?.data?.consultant?.name,
    userdatarole: consultantDetails?.data?.consultant?.role,
     company: consultantDetails?.data?.consultant?.company?.name,
    joinedDate: consultantDetails?.data?.consultant?.created_at,
    cnic: consultantDetails?.data?.consultant?.cnic,
    mobile: consultantDetails?.data?.consultant?.mobile_number,
    city: consultantDetails?.data?.consultant?.city,
    address: consultantDetails?.data?.consultant?.address,
   // Accessing the 4th item (index 3)
   // account_status: consultant?.account_status,
    account_status: consultantDetails?.data?.consultant?.account_status,
    otp_status: consultantDetails?.data?.consultant?.otp_status,
  };


  // const userData = {
  //     name: "Andrew hjajjaj",
  //     email: "user@gmail.com",
  //     joinedDate: "8/2/2024",
  //     cnic: "34000-90909090-7",
  //     mobile: "+967654546655",
  //     city: "rawat",
  //     address: "st#3, H#4, gulberg green",
  //     land: "10 Acre",
  //     Totaltasks: "300",
  //     completedtaskfarmers: "07",
  //     pendingtaskfarmers: "09",
  //     empty: " ",
  //   };

  const userDetailsArray = [
    { label: "Mobile Number", value: userData.mobile },
    { label: "City", value: userData.city },
    { label: "Address", value: userData.address },
     { label: "Company", value: userData.company || "N/A" }, // Use company name if available
    // { label: "Total Tasks", value: userData.Totaltasks },
    // { label: "No of Farmers with Completed Tasks", value: userData.completedtaskfarmers },
    // { label: "No of Farmers with Pending Tasks", value: userData.pendingtaskfarmers },
    //{ label: " ", value: userData.empty },
  ];

  const customersArray = consultantDetails?.data?.consultant?.consultants?.map((farmer) => ({
    name: farmer?.farmerUser?.name || "N/A", // Use farmer's name or a default value if missing
    imageUrl:
      farmer?.farmerUser?.profile_image ||
      "https://s3-alpha-sig.figma.com/img/3c5c/63c4/92615f4a0b7a99dc8c2e8b8788739d67?Expires=1731888000&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=gHRZJw62W7-8A6gBKHdSuohyRgpIs4BD7LLERzzjYIsYDZSQbIuDCOfmVU6rd-Ad3BRnJ4v7vJXDNBKz~Jq~PcJWWTOgvInHSQ6WR-tNgGIa~Pa-8a9dLB6XwH4yAyDW18eohM8hMwNtueAJi0BtoGkIud~7E5RhfWF7YFrZDUs-6JAug1i7c2AjlST6bhYur0FTdIZ6Tsl6emGV0-WevJKdt1rn~WfpUiZ2qwRDBfw0ctNB91LwTwVjQJC0ddmo~4Exfd7U8WWqAm-Hu5~xnfTx6PcdTugCEd16NG0JOpUB0I53RsxGcifnA0l8H9zm1yiCA4DVoE1JM8dUSvCjIA__", // Use profile_image or a placeholder
    profileLink: `/farmer/${farmer?.farmerUser?.id}`, // Create a profile link using the farmer's ID
    state: farmer?.farmerUser, // Create a profile link using the farmer's ID
  }));

  const showLink = true;
  const complaints =
  consultantDetails?.data?.consultant?.consultantComplaints && Array.isArray(consultantDetails?.data?.consultant.consultantComplaints)
      ? consultantDetails?.data?.consultant?.consultantComplaints?.map((complain) => ({
          id: complain?.id,
          text: complain?.complain_description,
          user: complain?.user?.name || "NEW FARMER", // Make sure 'user' exists, if not, fallback to "NEW FARMER"
          status: complain?.complain_status,
          date: new Date(complain?.date_time).toLocaleString(), // Convert date_time to a readable format
        }))
      : [];

  // // Sample complaint data
  // const complaints = [
  //   { id: 123, text: 'The delivery was delayed by two days.', user: 'John Doe', status: 'resolved', date: 'Oct 12, 2024, 3:00 PM' },
  //   { id: 124, text: 'Product quality was poor.', user: 'Jane Smith', status: 'pending', date: 'Oct 12, 2024, 3:00 PM' },
  //   { id: 125, text: 'Unable to contact support.', user: 'Adam Lee', status: 'pending', date: 'Oct 12, 2024, 3:00 PM' },
  // ];
  // Loading state
  if (isLoading) {
    return (
      <div className="loaderOverlay">
        <img src={Loader} alt="Loader" />
      </div>
    );
  }
  return (
    <Container>
      <Row>
        <Col lg={12} className="breadcrum-container ">
          <Row className="breadcrum-container  py-3">
            <Col lg={12}>
              <div className="custom-breadcrumb">
                {/* <span><a href="/">Home</a></span> */}
                <img src={ICONS.consultant} className="icon" />
                <span>
                  <a href="/consultants">Consultants</a>
                </span>
                <span>
                  {userData.name}({userData.id})
                </span>
              </div>
            </Col>
          </Row>
        </Col>

        <Col lg={12} className="component-container mb-2">
          <UserComponent user={userData} userDetails={userDetailsArray} />
        </Col>
      </Row>
      {userData.account_status === "Approved" && (
        <Row className="d-flex justify-content-between two-columns">
          <Col lg={5} className="component-container mb-2">
            <TitleComponent title="Farmers" />
            <CustomerComponent customers={customersArray} />
          </Col>

          <Col lg={5} className="component-container mb-2">
            {/* <TitleComponent title="Feedbacks" /> */}
            <ComplainComponent title="Complains" complaints={complaints} />
          </Col>
        </Row>
      )}
    </Container>
  );
};

export default Consultant;
